module.exports = __webpack_public_path__ + "static/media/19.7623e927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/19.jpg
// module id = 709
// module chunks = 0